function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createVNode as _createVNode } from "vue";
import { provide, computed, defineComponent } from "vue";
import { kebabCase, makeStringProp, createNamespace } from "../utils";

var _createNamespace = createNamespace("config-provider"),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

var CONFIG_PROVIDER_KEY = Symbol(name);
var configProviderProps = {
  tag: makeStringProp("div"),
  themeVars: Object,
  iconPrefix: String
};

function mapThemeVarsToCSSVars(themeVars) {
  var cssVars = {};
  Object.keys(themeVars).forEach(function (key) {
    cssVars["--van-".concat(kebabCase(key))] = themeVars[key];
  });
  return cssVars;
}

var stdin_default = defineComponent({
  name: name,
  props: configProviderProps,
  setup: function setup(props, _ref) {
    var slots = _ref.slots;
    var style = computed(function () {
      if (props.themeVars) {
        return mapThemeVarsToCSSVars(props.themeVars);
      }
    });
    provide(CONFIG_PROVIDER_KEY, props);
    return function () {
      return _createVNode(props.tag, {
        "class": bem(),
        "style": style.value
      }, {
        "default": function _default() {
          var _a;

          return [(_a = slots["default"]) == null ? void 0 : _a.call(slots)];
        }
      });
    };
  }
});
export { CONFIG_PROVIDER_KEY, stdin_default as default };